<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <BaseModal v-model="commentsModal" size="lg">
            <DenounceComments :denounceId="selected[0]?.id" />
        </BaseModal>

        <BaseModal v-model="resolveModal" size="lg">
            <DenounceResolve :denunciationId="selected[0]?.id" @alert="showAlert" @close="toggleResolveModal" />
        </BaseModal>

        <b-table :busy="isBusy" :fields="fields" :items="filteredItems" sticky-header="50vh" responsive
            no-border-collapse select-mode="single" selectable @row-selected="onRowSelected" show-empty>

            <template #empty>
                <b-card v-if="dateQuery" class="text-center my-2 fs-5">
                    No se realizaron denuncias en el periodo seleccionado
                </b-card>
                <b-card v-else-if="searchQuery" class="text-center my-2 fs-5">
                    No hay denuncias que coincidan con los criterios de búsqueda
                </b-card>
                <b-card v-else class="text-center my-2 fs-5">
                    Aún no se ha recibido ninguna denuncia
                </b-card>
            </template>
            <!-- Icono de carga de tabla -->
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando datos de tabla...</strong>
                </div>
            </template>

            <template #cell(selected)="{ item, rowSelected }">
                <div class="btn-group" v-if="rowSelected">
                    <b-button @click="openModalLinkEvidencia" type="button" variant="outline-primary"
                        v-b-tooltip.hover="'Mostrar evidencia'" size="sm">
                        <b-icon icon="file-earmark-medical-fill" font-scale="1"></b-icon>
                    </b-button>

                    <button @click="openModalComments" type="button" class="btn btn-outline-secondary btn-sm"
                        v-b-tooltip.hover="'Comentarios'">
                        <b-icon icon="chat-left-text" font-scale="1"></b-icon>
                    </button>

                    <button
                        v-if="!isResolved(item)"
                        v-permission="'denuncias-resolver'"
                        @click="toggleResolveModal" type="button"
                        class="btn btn-outline-secondary btn-sm" v-b-tooltip.hover="'Resolver denuncia'">
                        <b-icon icon="check-square-fill" font-scale="1"></b-icon>
                    </button>
                </div>
                <template v-else>
                    <b-icon icon="three-dots" font-scale="1" class="icone-not-select"></b-icon>
                </template>
            </template>

            <!-- Botón de detalles -->
            <template #cell(detalle)="row">
                <ToggleDetailsButton @click="row.toggleDetails" :showing="row.detailsShowing" />
            </template>

            <template #cell(approval)="row">
                <span v-if="row.item.approval === null" class="badge bg-dark">
                    Pendiente
                </span>
                <span v-else-if="row.item.approval.approved" class="badge bg-success">
                    Aprobado
                </span>
                <span v-else class="badge bg-danger">
                    Rechazado
                </span>
            </template>

            <!-- Cuerpo de detalle -->
            <template #row-details="row">
                <b-card class="m-3">
                    <b-table-lite small :items="row.item.respuestas" :fields="questionFields" class="table-borderless">
                    </b-table-lite>
                    <hr>
                    <b>Estado del proceso:</b> {{ approvalMessage(row) }}
                    <br>
                    <span v-if="isResolved(row.item)">
                        <b>Fundamento de la resolución:</b>
                        {{ approvalReason(row) }}
                    </span>
                </b-card>
            </template>
        </b-table>
    </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { mapActions, mapGetters } from 'vuex';
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import { convertAccuserType } from '@/plugins/complianceScripts/index.js'
import BaseModal from '@/components/shared/Base-modal.vue'
import DenounceComments from './DenounceTable/Denounce-comments.vue'
import DenounceResolve from './DenounceTable/Denounce-resolve.vue'
import ToggleDetailsButton from '@/components/shared/Toggle-details-button.vue';

export default {
    name: 'DenounceTable',

    components: {
        AlertDismiss,
        BaseModal,
        DenounceComments,
        DenounceResolve,
        ToggleDetailsButton
    },

    data() {
        return {
            isBusy: false,
            items: [],
            selected: [],
            fields: [
                { key: 'accuserNombre', label: 'Usuario acusador' },
                { key: 'accuserCorreo', label: 'Correo acusador' },
                { key: 'accuserTipo', label: 'Tipo' },
                { key: 'approval', label: 'Estado' },
                { key: 'detalle', label: 'Detalle' },
                { key: 'selected', label: 'Opciones' }
            ],
            questionFields: [
                { key: 'preguntaName', label: 'Pregunta' },
                {
                    key: 'respuestaData',
                    label: 'Respuesta',
                    formatter: (value) => {
                        return value.slice(1, value.length - 1);
                    }
                }
            ],

            searchQuery: '',

            commentsModal: false,
            resolveModal: false,
            dateQuery: null,
        }
    },

    async mounted() {
        this.$eventBus.$on(EventNames.PaginationFilterDenounce, async (query) => {
            this.processingTable();

            let page = query.page - 1; //se resta 1 por que el indice comienza en 0
            let pageSize = query.pageSize;

            await this.getAllDenunciations(page, pageSize);

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.FilterDenounceAfterSearch, (query) => {
            this.processingTable();

            this.searchQuery = query

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.FilterDenounceByDate, async (query) => {
            this.processingTable();
            this.dateQuery = query;
        

            await this.getAllDenunciationsByDate(query);

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.ClearFilterDenounce, async () => {
            this.processingTable();
            this.dateQuery = null;
            this.searchQuery = '';

            await this.getAllDenunciations(0, InitPageSize.DenouncePageSize);

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.CreateDenunciation, async (query) => {
            this.processingTable();

            let page = query.page - 1; //se resta 1 por que el indice comienza en 0
            let pageSize = query.pageSize;

            await this.getAllDenunciations(page, pageSize);

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.ResolvedDenunciation, async (query) => {
            this.processingTable();

            let page = query.page - 1; //se resta 1 por que el indice comienza en 0
            let pageSize = query.pageSize;

            await this.getAllDenunciations(page, pageSize);

            this.processingTable();
        });
    },

    computed: {
        ...mapGetters(["getSession", "getRole"]),

        filteredItems() {
            let filtered = this.items;

            // Filtrar por búsqueda por nombre, apellido, etc.
            if (this.searchQuery) {
                filtered = this.filterForSearch(filtered, this.searchQuery)
            }

            return filtered;
        }
    },

    methods: {
        ...mapActions([
            "allDenunciationsByPage",
            "allDenunciationsByDate"
        ]),

        processingTable() {
            this.isBusy = !this.isBusy
        },

        async getAllDenunciations(page, pageSize) {
            this.items = []

            let denunciations = await this.allDenunciationsByPage({
                page: page,
                pageSize: pageSize,
            });

            if (denunciations.isError) {
                this.$refs.alertDismiss.showAlert(denunciations.message);
                return;
            }

            this.items = this.convertData(denunciations.data);
        },

        async getAllDenunciationsByDate(query) {
            this.items = []

            let denunciations = await this.allDenunciationsByDate({
                initDate: query.startDate,
                finalDate: query.endDate
            })

            if (denunciations.isError) {
                this.$refs.alertDismiss.showAlert(denunciations.message);
                return;
            }

            this.items = this.convertData(denunciations.data);
        },  

        convertData(data) {
            return data.map((d) => {
                return {
                    id: d.id,
                    route: d.route,

                    respuestas: d.answers.map((r) => {
                        return {
                            id: r.id,
                            respuestaData: r.dynamicFieldJson,

                            preguntaId: r.questionId,
                            preguntaName: r.questionName
                        }
                    }),

                    accuserNombre: d.accuser?.name ?? 'No registrado',
                    accuserCorreo: d.accuser?.mail ?? 'No registrado',
                    accuserTipo: convertAccuserType(d.accuser?.type ?? null),
                    approval: d.approval,
                }
            });
        },

        onRowSelected(items) {
            this.selected = items;
        },

        openModalLinkEvidencia() {
            this.$eventBus.$emit(EventNames.OpenModalEvidenciaLink, this.selected);
        },

        openModalComments() {
            this.commentsModal = true;
        },

        toggleResolveModal() {
            this.resolveModal = !this.resolveModal;
        },

        filterForSearch(denunces, searchQuery) {
            const normalizedQuery = searchQuery.toLowerCase().trim();

            return denunces.filter(item =>
                Object.values(item).some(value =>
                    value?.toString().toLowerCase().includes(normalizedQuery)
                )
            );
        },

        isResolved(item) {
            return item.approval !== null;
        },

        approvalMessage(row) {
            let firstPart
            if (row.item.approval === null) {
                firstPart = 'Pendiente';
            } else if (row.item.approval.approved) {
                firstPart = 'Aprobado';
            } else {
                firstPart = 'Rechazado';
            }

            let secondPart = row.item.approval ? ' por ' + row.item.approval.approverMail : '';

            return firstPart + secondPart;
        },

        approvalReason(row) {
            return row.item.approval.reason;
        },

        showAlert({ message, type }) {
            this.$refs.alertDismiss.showAlert(message, type);
        },
    }

}
</script>
